export default __webpack_public_path__ + "static/media/female-back.6c254d0a.png";